export { default as translate } from './translate';
export { default as I18n } from './I18n';
export { default as Interpolate } from './Interpolate';
export { default as Trans } from './Trans';
export { default as I18nextProvider } from './I18nextProvider';
export { default as loadNamespaces } from './loadNamespaces';
export { reactI18nextModule, setDefaults, getDefaults, setI18n, getI18n } from './context';


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-i18next/dist/es/index.js
// module id = 23
// module chunks = 0